/*
@file    index.jsx

@author Carlos Sepúlveda. <csepulveda@atentus.com>
(c) Servicios de Monitoreo S.A. - Santiago, Chile

@brief  Realiza petición a la api para almacenar datos en reporte.notificacion_control, para gestionar la visibiidad de las notificaciones en el reporte.
@date   Feb/2021

*/
import { api_host,api_auth} from '../../common/globals/constants';
/*
@brief Método que permite realizar una petición post para desactivar las notificaciones
@param notificationsId  notificaciones ids a ingresar al control de notificaciones
@param cliUsrId  usuario id de reporte.
@param token  corresponde a el token de autentificacion para la api.
@return Response Información respecto al estado de la consulta.
En caso contrario o para algún error:
- Ocurre algún problema: Response con estado 3.
*/
export const createNotificationControl = (notificationsId, cliUsrId, token) =>

    fetch(api_host+`/reporte/general/notificationControl/?&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2`, {
        method: 'POST', // or 'PUT'
        body: JSON.stringify({'notificacion_id': notificationsId.toString(),
            'cliente_usuario_id': cliUsrId,'token':token}), //

        headers: {
            'Content-Type': 'application/json'
        }
        }).then(response => response.json())
